/* @flow */
import Chat from 'entities/Chat';
import ChatActions from 'chat/actions/ChatActions';
import ChatMember from 'entities/ChatMember';
import React from 'react';
import ReportToRemindSelectModal from 'support/components/ReportToRemindSelectModal.jsx';

class ReportChatSelectModal extends React.Component {
  static propTypes = {
    chat: React.PropTypes.instanceOf(Chat).isRequired,
    partner: React.PropTypes.instanceOf(ChatMember).isRequired,
  };

  reportChat = (reason: string, notes: ?string) => {
    const { chat, partner } = this.props;
    ChatActions.reportChat(chat.id, partner.getUuid(), reason, notes);
  };

  render() {
    return (
      <ReportToRemindSelectModal
        {...this.props}
        reportee={this.props.partner.getName()}
        notesPlaceholder={'Why are you reporting ' + this.props.partner.getName() + '?'}
        onReport={this.reportChat}
      />
    );
  }
}

export default ReportChatSelectModal;



// WEBPACK FOOTER //
// ./src/chat/components/ReportChatSelectModal.jsx